export default function navigatorShare({
  title,
  text,
  url,
}: {
  title: string;
  text: string;
  url: string;
}): void {
  if (!(navigator as any).share) {
    return;
  }
  (navigator as any).share({
    title,
    text,
    url,
  });
}
